export default {
  namespaced: true,
  state: {
    notifications: [],
  },
  mutations: {
    /**
     * Clear all notifications
     * @param {Object} state
     * @returns {Void}
     */
    clearAll(state) {
      state.notifications = [];
    },
    /**
     * Clear one notification by id
     * @param {Object} state
     * @param {String} id
     * @returns {Void}
     */
    clearOne(state, id) {
      state.notifications = state.notifications.filter(notification => notification.id !== id);
    },
    /**
     * Add notification
     * @param {Object} state
     * @param {Object} notification
     * @returns {Void}
     */
    add(state, notification) {
      state.notifications.push(notification);
    },
  },
  getters: {
    /**
     * Return all notifications or based on {type}
     * @param {Object} state
     * @param {String} state
     * @returns {Array}
     */
    get: state => type => (type ? state.notifications.filter(notification => notification.type === type) : state.notifications),
  },
  actions: {
    /**
     * Create and add notification
     * @param {Object} param0
     * @param {Function} param0.commit
     * @param {Object} param0.state
     * @param {Object} param1
     * @param {String} param1.message
     * @param {String} param1.secondaryMessage
     * @param {Object} param1.button
     * @param {String} param1.type
     * @param {String} param1.state
     * @returns {String|Null}
     */
    add: ({
      commit,
      state,
    }, {
      message,
      secondaryMessage,
      button,
      type,
      clearable = false,
      state: notificationState,
    }) => {
      // Check so we dont have a notification with this text already
      if (state.notifications.filter(notification => notification.message === message).length > 0) {
        return null;
      }

      const id = Math.random();

      commit('add', {
        message,
        secondaryMessage,
        button,
        type,
        state: notificationState,
        clearable,
        id,
      });

      return id;
    },
  },
};
